import { ModelSagres } from "@/types/model-sagres";

export interface MetricaAvaliacaoGeralJson {
  id: number;
  metricaDs: string;
  metricaAnuals: {
    id: number;
    ano: number;
  }[]
}

export class MetricaAvaliacaoGeral extends ModelSagres {
  id: number;
  metricaDs: string;
  metricaAnuals: {
    id: number;
    ano: number;
  }[];

  /**
   * @param obj
   */
  constructor(obj?: MetricaAvaliacaoGeralJson) {
    super();
    if (obj) {
      this.id = obj.id;
      this.metricaDs = obj.metricaDs;
      this.metricaAnuals = obj.metricaAnuals;
    }
  }
}